import classNames from 'classnames';

import ActionIcon from 'components/BaseHelpers/ActionIcon';
import { IconType } from 'components/BaseHelpers/ActionIcon/ActionIcon';
import BaseCta, { BaseCtaProps } from 'components/BaseHelpers/BaseCta';
import Text from 'components/BaseHelpers/Text/Text';

import styles from './TextCTA.module.scss';

type OwnProps = {
  label?: string;
  size?: 'default' | 'small' | 'large';
  iconVariant?: 'white' | 'yellow' | 'inherit';
  className?: string;
};

export type TextCTAProps = OwnProps & BaseCtaProps;

const TextCTA = (props: TextCTAProps): JSX.Element | null => {
  const { tag, label, size = 'default', iconVariant = 'white', className } = props;

  if (!label) return null;

  const ctaClass = classNames(styles.link, styles[size], className);
  const iconClass = classNames(styles.icon, styles[`icon--${iconVariant}`]);

  if (tag === 'a') {
    const { target } = props;

    const { iconVariant, ...propsToPassOn } = props;
    const iconExternalClass = classNames(target === '_blank' && styles.iconExternal);

    let type: IconType = 'standard';
    if (props.href.includes('tel:')) {
      type = 'telephone';
    } else if (props.href.includes('mailto:')) {
      type = 'email';
    }

    return (
      <BaseCta {...propsToPassOn} className={ctaClass}>
        <Text className={styles.label} field={label} />
        <ActionIcon
          aria-hidden
          external={target === '_blank'}
          className={classNames(iconClass, iconExternalClass)}
          size={size}
          type={type}
        />
      </BaseCta>
    );
  }

  if (tag === 'button' || tag === 'span') {
    const { iconVariant, ...propsToPassOn } = props;

    return (
      <BaseCta {...propsToPassOn} className={ctaClass}>
        <Text className={styles.label} field={label} />
        <ActionIcon aria-hidden className={iconClass} size={size} />
      </BaseCta>
    );
  }

  return null;
};

export default TextCTA;
